import { InvokeCallback, Sender } from "xstate";
import { withToken } from "@rentablo/api";
import { investmentsId } from "@rentablo/api/apiv1";
import { DividendWizardContext } from "../types/dividendWizardContext";
import { DividendWizardEvent } from "../types/dividendWizardEvent";

export const loadInvestment =
  (
    context: DividendWizardContext,
    event: DividendWizardEvent
  ): InvokeCallback<DividendWizardEvent, DividendWizardEvent> =>
  (callback) => {
    if (
      event.type !== "INIT_FROM_INVESTMENT" &&
      event.type !== "INIT_FROM_DIVIDEND"
    )
      throw new Error(`Invalid event type ${event.type}`);

    load(event.investmentId, callback);
  };

const load = async (
  investmentId: number,
  callback: Sender<DividendWizardEvent>
) => {
  const getInvestment = withToken(investmentsId);
  try {
    const investment = await getInvestment({ id: investmentId });

    callback({
      type: "LOADED_INVESTMENT",
      investment,
    });
  } catch (e) {
    callback({
      type: "SOMETHING_WRONG",
      error: e as AxiosApiError,
    });
  }
};
